import { render, staticRenderFns } from "./whole.vue?vue&type=template&id=6249ff33&scoped=true"
import script from "./whole.vue?vue&type=script&lang=js"
export * from "./whole.vue?vue&type=script&lang=js"
import style0 from "./whole.vue?vue&type=style&index=0&id=6249ff33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6249ff33",
  null
  
)

export default component.exports